import { Coins, FileCode2, Grid3x3, Network, Rocket, Wallet } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";

const MODULES = [
    { icon: FileCode2, title: "Smart Contract", desc: "A certified BEP20 smart-contract ecosystem — automated, transparent and secure." },
    { icon: Network, title: "Affiliate Distribution", desc: "A structured 7-level distribution model sharing rewards across the upline chain." },
    { icon: Grid3x3, title: "Matrix", desc: "A 12-slot matrix system with 10 active slots and a built-in recycle mechanism." },
    { icon: Coins, title: "AFG Token", desc: "A blockchain-based token distribution system with a fixed 500,000 AFG supply." },
    { icon: Wallet, title: "Salary Fund", desc: "A monthly salary distribution model funded by 10% of every level purchase." },
];

const FUTURE = ["Token Trade", "Gold Global Program", "AFG DEX Listing", "Nexora Wallet"];

export const CoreModules = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="core-modules-section" className="border-t border-white/5 bg-nx-alt py-20 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
                <SectionHeader
                    label={t("Core Ecosystem")}
                    testId="core-modules"
                    title={<>{t("One Ecosystem.")}<br />{t("Multiple Possibilities.")}</>}
                />
                <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
                    {MODULES.map((m, i) => (
                        <Reveal key={m.title} delay={i * 0.06}>
                            <div
                                className="group h-full rounded-2xl border border-white/5 bg-nx-elev p-7 transition-all duration-300 hover:-translate-y-1 hover:border-white/10 lg:p-8"
                                data-testid={`module-${m.title.toLowerCase().replace(/\s+/g, "-")}`}
                            >
                                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-nx-soft">
                                    <m.icon size={20} strokeWidth={1.5} className="text-nx-lime" aria-hidden="true" />
                                </div>
                                <h3 className="mt-6 text-lg font-extrabold tracking-tight text-nx-text">{t(m.title)}</h3>
                                <p className="mt-2.5 text-sm leading-relaxed text-nx-sub">{t(m.desc)}</p>
                            </div>
                        </Reveal>
                    ))}
                    <Reveal delay={0.3}>
                        <div
                            className="group h-full rounded-2xl border border-nx-lime/20 bg-nx-lime/[0.05] p-7 transition-all duration-300 hover:-translate-y-1 hover:border-nx-lime/35 lg:p-8"
                            data-testid="module-future-products"
                        >
                            <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-nx-lime/25 bg-nx-lime/10">
                                <Rocket size={20} strokeWidth={1.5} className="text-nx-lime" aria-hidden="true" />
                            </div>
                            <h3 className="mt-6 text-lg font-extrabold tracking-tight text-nx-text">{t("Future Products")}</h3>
                            <ul className="mt-4 space-y-2.5">
                                {FUTURE.map((f) => (
                                    <li key={f} className="flex items-center justify-between gap-3 text-sm font-semibold text-nx-text">
                                        <span>{t(f)}</span>
                                        <span className="shrink-0 rounded-full border border-nx-lime/30 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.12em] text-nx-lime">
                                            {t("Coming Soon")}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
};
